import { type, Functor, map, Semigroup, filter, append, stable } from 'funcadelic';
import SymbolObservable from 'symbol-observable';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function CachedProperty(key, reify) {
  var enumerable = true;
  var configurable = true;
  return {
    enumerable: enumerable,
    configurable: configurable,
    get: function get() {
      var value = reify(this);
      Object.defineProperty(this, key, {
        enumerable: enumerable,
        value: value
      });
      return value;
    }
  };
}

var _class, _temp;
var Tree = type((_temp = _class = function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  _createClass(_class, [{
    key: "childAt",
    value: function childAt(key, parent) {
      if (parent[Tree.symbol]) {
        return this(parent).childAt(key, parent);
      } else {
        return parent[key];
      }
    }
  }, {
    key: "defineChildren",
    value: function defineChildren(fn, parent) {
      if (parent[Tree.symbol]) {
        return this(parent).defineChildren(fn, parent);
      } else {
        var _arr = Object.keys(parent);

        var _loop = function _loop() {
          var property = _arr[_i];
          Object.defineProperty(parent, property, CachedProperty(property, function () {
            return fn(property, parent);
          }));
        };

        for (var _i = 0; _i < _arr.length; _i++) {
          _loop();
        }
      }
    }
  }]);

  return _class;
}(), _defineProperty(_class, "name", 'Tree'), _temp));
var _Tree$prototype = Tree.prototype,
    childAt = _Tree$prototype.childAt,
    defineChildren = _Tree$prototype.defineChildren;

var Box = function () {
  _createClass(Box, null, [{
    key: "unwrap",
    value: function unwrap(box) {
      return box.value;
    }
  }, {
    key: "of",
    get: function get() {
      var _this = this;

      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _construct(_this, args);
      };
    }
  }]);

  function Box(value) {
    _classCallCheck(this, Box);

    this.value = value;
  }

  return Box;
}();

var unwrap = Box.unwrap;

var Id = function (_Box) {
  _inherits(Id, _Box);

  function Id() {
    _classCallCheck(this, Id);

    return _possibleConstructorReturn(this, _getPrototypeOf(Id).apply(this, arguments));
  }

  return Id;
}(Box);

var Const = function (_Box2) {
  _inherits(Const, _Box2);

  function Const() {
    _classCallCheck(this, Const);

    return _possibleConstructorReturn(this, _getPrototypeOf(Const).apply(this, arguments));
  }

  return Const;
}(Box);

Functor.instance(Id, {
  map: function map$$1(fn, id) {
    return Id.of(fn(id.value));
  }
});
Functor.instance(Const, {
  map: function map$$1(fn, constant) {
    return constant;
  }
});
function compose(f, g) {
  return function () {
    return f(g.apply(void 0, arguments));
  };
}
function view(lens, context) {
  var get = compose(unwrap, lens(Const.of));
  return get(context);
}
function over(lens, fn, context) {
  var update = compose(unwrap, lens(compose(Id.of, fn)));
  return update(context);
}
function set$1(lens, value, context) {
  return over(lens, function () {
    return value;
  }, context);
}
function Lens(get, set) {
  return function (f) {
    return function (context) {
      return map(function (value) {
        return set(value, context);
      }, f(get(context)));
    };
  };
}
var transparent = Lens(function (x) {
  return x;
}, function (y) {
  return y;
});
function At(property, container) {
  var get = function get(context) {
    return context != null ? childAt(property, context) : undefined;
  };

  var set = function set(part, whole) {
    var context = whole == null ? Array.isArray(container) ? [] : {} : whole;

    if (part === context[property]) {
      return context;
    } else if (Array.isArray(context)) {
      var clone = context.slice();
      clone[Number(property)] = part;
      return clone;
    } else {
      return Semigroup.for(Object).append(context, _defineProperty({}, property, part));
    }
  };

  return Lens(get, set);
}
function Path(path) {
  return path.reduce(function (lens, key) {
    return compose(lens, At(key));
  }, transparent);
}

var Meta = function Meta(object, value) {
  _classCallCheck(this, Meta);

  this.root = object;
  this.lens = transparent;
  this.path = [];
  this.value = value;
  this.source = object;
};

_defineProperty(Meta, "symbol", Symbol('Meta'));

_defineProperty(Meta, "data", At(Meta.symbol));

_defineProperty(Meta, "lens", compose(Meta.data, At('lens')));

_defineProperty(Meta, "path", compose(Meta.data, At('path')));

_defineProperty(Meta, "value", compose(Meta.data, At('value')));

_defineProperty(Meta, "source", compose(Meta.data, At('source')));

function metaOf(object) {
  return view(Meta.data, object);
}
function valueOf(object) {
  var meta = metaOf(object);
  return meta != null ? meta.value : object;
}
function sourceOf(object) {
  return view(Meta.source, object);
}
function mount(microstate, substate, key) {
  var parent = view(Meta.data, microstate);
  var prefix = compose(parent.lens, At(key, parent.value));
  return over(Meta.data, function (meta) {
    return {
      get root() {
        return parent.root;
      },

      get lens() {
        return compose(prefix, meta.lens);
      },

      get path() {
        return parent.path.concat([key]).concat(meta.path);
      },

      get value() {
        return meta.value;
      },

      get source() {
        return meta.source;
      }

    };
  }, substate);
}

var getPrototypeOf = Object.getPrototypeOf,
    getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors,
    assign = Object.assign;
function methodsOf(Type) {
  return filter(function (_ref) {
    var name = _ref.key,
        desc = _ref.value;
    return name !== 'constructor' && typeof name === 'string' && typeof desc.value === 'function';
  }, getAllPropertyDescriptors(Type.prototype));
}

function getAllPropertyDescriptors(object) {
  if (object === Object.prototype) {
    return {};
  } else {
    var prototype = getPrototypeOf(object);
    return assign(getAllPropertyDescriptors(prototype), getOwnPropertyDescriptors(object));
  }
}

var Primitive = function () {
  function Primitive() {
    _classCallCheck(this, Primitive);
  }

  _createClass(Primitive, [{
    key: "state",
    get: function get() {
      return valueOf(this);
    }
  }]);

  return Primitive;
}();

var Any = function (_Primitive) {
  _inherits(Any, _Primitive);

  function Any() {
    _classCallCheck(this, Any);

    return _possibleConstructorReturn(this, _getPrototypeOf(Any).apply(this, arguments));
  }

  return Any;
}(Primitive);

function parameterized(fn) {
  function initialize() {
    var Type = fn.apply(void 0, arguments);

    if (Type.initialize) {
      Type.initialize();
    }

    return Type;
  }

  var defaultTypeParameters = new Array(fn.length);
  defaultTypeParameters.fill(Any);
  var DefaultType = initialize.apply(void 0, defaultTypeParameters);

  DefaultType.of = function () {
    return initialize.apply(void 0, arguments);
  };

  return DefaultType;
}

var ObjectType = parameterized(function (T) {
  var _class, _Symbol$iterator, _temp;

  return _temp = (_Symbol$iterator = Symbol.iterator, _class = function () {
    _createClass(ObjectType, null, [{
      key: "name",
      get: function get() {
        return "Object<".concat(T.name, ">");
      }
    }]);

    function ObjectType(value) {
      var _this = this;

      _classCallCheck(this, ObjectType);

      Object.keys(value || {}).forEach(function (key) {
        Object.defineProperty(_this, key, {
          enumerable: true,
          configurable: true,
          get: function get() {
            return create(T, value[key]);
          }
        });
      });
    }

    _createClass(ObjectType, [{
      key: "initialize",
      value: function initialize(value) {
        return value == null ? {} : this;
      }
    }, {
      key: "assign",
      value: function assign(attrs) {
        return append(valueOf(this), map(valueOf, attrs));
      }
    }, {
      key: "put",
      value: function put(name, value) {
        return this.assign(_defineProperty({}, name, value));
      }
    }, {
      key: "delete",
      value: function _delete(name) {
        return filter(function (_ref) {
          var key = _ref.key;
          return key !== name;
        }, valueOf(this));
      }
    }, {
      key: "map",
      value: function map$$1(fn) {
        return map(function (value) {
          return valueOf(fn(create(T, value)));
        }, valueOf(this));
      }
    }, {
      key: "filter",
      value: function filter$$1(fn) {
        return filter(function (_ref2) {
          var key = _ref2.key,
              value = _ref2.value;
          return valueOf(fn(create(T, value), key));
        }, valueOf(this));
      }
    }, {
      key: _Symbol$iterator,
      value: function value() {
        var object = this;
        var iterator = Object.keys(valueOf(this))[Symbol.iterator]();
        return {
          next: function next() {
            var next = iterator.next();
            return {
              get done() {
                return next.done;
              },

              get value() {
                return new Entry(next.value, object[next.value]);
              }

            };
          }
        };
      }
    }]);

    return ObjectType;
  }()), _defineProperty(_class, "T", T), _temp;
});

var Entry = function () {
  function Entry(key, value) {
    _classCallCheck(this, Entry);

    this.key = key;
    this.value = value;
  }

  _createClass(Entry, [{
    key: Symbol.iterator,
    value: function value() {
      return [this.value, this.key][Symbol.iterator]();
    }
  }]);

  return Entry;
}();

var ArrayType = parameterized(function (T) {
  var _class, _Symbol$iterator, _temp;

  return _temp = (_Symbol$iterator = Symbol.iterator, _class = function () {
    function ArrayType() {
      _classCallCheck(this, ArrayType);
    }

    _createClass(ArrayType, [{
      key: "initialize",
      value: function initialize(value) {
        if (value == null) {
          return [];
        } else if (Array.isArray(value)) {
          return value;
        } else {
          return [value];
        }
      }
    }, {
      key: "push",
      value: function push(value) {
        return _toConsumableArray(valueOf(this)).concat([valueOf(value)]);
      }
    }, {
      key: "pop",
      value: function pop() {
        return valueOf(this).slice(0, -1);
      }
    }, {
      key: "shift",
      value: function shift() {
        var _valueOf = valueOf(this),
            _valueOf2 = _toArray(_valueOf),
            rest = _valueOf2.slice(1);

        return rest;
      }
    }, {
      key: "unshift",
      value: function unshift(value) {
        return [valueOf(value)].concat(_toConsumableArray(valueOf(this)));
      }
    }, {
      key: "slice",
      value: function slice(begin, end) {
        var list = valueOf(this);
        var result = list.slice(begin, end);
        return list.length === result.length ? this : result;
      }
    }, {
      key: "sort",
      value: function sort(compareFn) {
        var init = valueOf(this);

        var result = _toConsumableArray(init).sort(compareFn);

        return init.every(function (member, idx) {
          return result[idx] === member;
        }) ? this : result;
      }
    }, {
      key: "filter",
      value: function filter$$1(fn) {
        var list = valueOf(this);
        var result = list.filter(function (member) {
          return fn(create(T, member));
        });
        return list.length === result.length ? this : result;
      }
    }, {
      key: "map",
      value: function map$$1(fn) {
        var list = valueOf(this);
        return list.reduce(function (result, member, index) {
          var mapped = valueOf(fn(create(T, member)));
          return set$1(At(index, result), mapped, result);
        }, list);
      }
    }, {
      key: "remove",
      value: function remove(item) {
        return this.filter(function (s) {
          return valueOf(s) !== valueOf(item);
        });
      }
    }, {
      key: "clear",
      value: function clear() {
        return [];
      }
    }, {
      key: _Symbol$iterator,
      value: function value() {
        var array = this;
        var iterator = valueOf(this)[Symbol.iterator]();
        var i = 0;
        return {
          next: function next() {
            var next = iterator.next();
            var index = i++;
            return {
              get done() {
                return next.done;
              },

              get value() {
                return childAt(index, array);
              }

            };
          }
        };
      }
    }, {
      key: "length",
      get: function get() {
        return valueOf(this).length;
      }
    }], [{
      key: "initialize",
      value: function initialize() {
        Tree.instance(this, {
          childAt: function childAt$$1(key, array) {
            if (typeof key === 'number') {
              var value = valueOf(array)[key];
              return mount(array, create(T, value), key);
            } else {
              return array[key];
            }
          },
          defineChildren: function defineChildren$$1(fn, array) {
            var generate = array[Symbol.iterator];
            return Object.defineProperty(array, Symbol.iterator, {
              enumerable: false,
              value: function value() {
                var iterator = generate.call(array);
                var i = 0;
                return {
                  next: function next() {
                    var next = iterator.next();
                    var index = i++;
                    return {
                      get done() {
                        return next.done;
                      },

                      get value() {
                        return fn(index, next.value, array);
                      }

                    };
                  }
                };
              }
            });
          }
        });
      }
    }, {
      key: "name",
      get: function get() {
        return "Array<".concat(T.name, ">");
      }
    }]);

    return ArrayType;
  }()), _defineProperty(_class, "T", T), _temp;
});

var BooleanType = function (_Primtive) {
  _inherits(BooleanType, _Primtive);

  function BooleanType() {
    _classCallCheck(this, BooleanType);

    return _possibleConstructorReturn(this, _getPrototypeOf(BooleanType).apply(this, arguments));
  }

  _createClass(BooleanType, [{
    key: "initialize",
    value: function initialize(value) {
      return !!value;
    }
  }, {
    key: "toggle",
    value: function toggle() {
      return !this.state;
    }
  }]);

  return BooleanType;
}(Primitive);

_defineProperty(BooleanType, "name", "Boolean");

var NumberType = function (_Primitive) {
  _inherits(NumberType, _Primitive);

  function NumberType() {
    _classCallCheck(this, NumberType);

    return _possibleConstructorReturn(this, _getPrototypeOf(NumberType).apply(this, arguments));
  }

  _createClass(NumberType, [{
    key: "initialize",
    value: function initialize(value) {
      if (value == null) {
        return 0;
      } else if (isNaN(value)) {
        return this;
      } else {
        return Number(value);
      }
    }
  }, {
    key: "increment",
    value: function increment() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return this.state + step;
    }
  }, {
    key: "decrement",
    value: function decrement() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return this.state - step;
    }
  }]);

  return NumberType;
}(Primitive);

_defineProperty(NumberType, "name", "Number");

var StringType = function (_Primitive) {
  _inherits(StringType, _Primitive);

  function StringType() {
    _classCallCheck(this, StringType);

    return _possibleConstructorReturn(this, _getPrototypeOf(StringType).apply(this, arguments));
  }

  _createClass(StringType, [{
    key: "initialize",
    value: function initialize(value) {
      if (value == null) {
        return '';
      } else {
        return String(value);
      }
    }
  }, {
    key: "concat",
    value: function concat(value) {
      return this.state.concat(value);
    }
  }]);

  return StringType;
}(Primitive);

_defineProperty(StringType, "name", "String");

var DSL = function () {
  function DSL() {
    var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, DSL);

    this.rules = rules;
  }

  _createClass(DSL, [{
    key: "expand",
    value: function expand(value) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var rule = _step.value;
          var result = rule.call(this, value);

          if (result && typeof result.Type === 'function') {
            return result;
          } else {
            continue;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        Type: Any,
        value: value
      };
    }
  }, {
    key: "use",
    value: function use(rule) {
      return new DSL(this.rules.concat(rule));
    }
  }]);

  return DSL;
}();

var dsl = new DSL().use(function matchBuiltins(value) {
  switch (value) {
    case Object:
      return {
        Type: ObjectType,
        value: {}
      };

    case Array:
      return {
        Type: ArrayType,
        value: []
      };

    case Boolean:
      return {
        Type: BooleanType,
        value: false
      };

    case Number:
      return {
        Type: NumberType,
        value: 0
      };
  }

  if (value === String) {
    return {
      Type: StringType,
      value: ''
    };
  }
}).use(function matchArrays(value) {
  if (Array.isArray(value) && value.length < 2) {
    var _value = _slicedToArray(value, 1),
        T = _value[0];

    var Type = T != null ? ArrayType.of(this.expand(T).Type) : ArrayType;
    return {
      Type: Type,
      value: []
    };
  }
}).use(function matchObjects(value) {
  if (value != null && _typeof(value) === 'object' && Object.keys(value).length < 2) {
    var _Object$keys = Object.keys(value),
        _Object$keys2 = _slicedToArray(_Object$keys, 1),
        key = _Object$keys2[0];

    if (key == null) {
      return {
        Type: ObjectType,
        value: {}
      };
    } else {
      var _this$expand = this.expand(value[key]),
          childType = _this$expand.Type;

      if (childType.isConstant) {
        return undefined;
      } else {
        return {
          Type: ObjectType.of(childType),
          value: {}
        };
      }
    }
  }
}).use(function matchCustomTypes(value) {
  if (typeof value === 'function') {
    return {
      Type: value,
      value: undefined
    };
  }
}).use(function matchConstants(value) {
  return {
    Type: Constant(value),
    value: value
  };
});

var Constant = function Constant() {
  var _class, _temp;

  return _temp = _class = function (_Primitive) {
    _inherits(Constant, _Primitive);

    function Constant() {
      _classCallCheck(this, Constant);

      return _possibleConstructorReturn(this, _getPrototypeOf(Constant).apply(this, arguments));
    }

    return Constant;
  }(Primitive), _defineProperty(_class, "isConstant", true), _temp;
};

var Storage = function () {
  function Storage(value) {
    var observe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
      return x;
    };

    _classCallCheck(this, Storage);

    this.value = value;
    this.observe = observe;
  }

  _createClass(Storage, [{
    key: "get",
    value: function get() {
      return this.value;
    }
  }, {
    key: "set",
    value: function set(value) {
      if (value !== this.value) {
        this.value = value;
        this.observe();
      }

      return this;
    }
  }, {
    key: "getPath",
    value: function getPath(path) {
      return view(Path(path), this.value);
    }
  }, {
    key: "setPath",
    value: function setPath(path, value) {
      return this.set(set$1(Path(path), value, this.value));
    }
  }]);

  return Storage;
}();

function Pathmap(Root, ref) {
  var paths = new Storage();

  var Location = function () {
    _createClass(Location, [{
      key: "currentValue",
      get: function get() {
        return view(this.lens, ref.get());
      }
    }, {
      key: "reference",
      get: function get() {
        if (!this.currentReference || this.currentValue !== valueOf(this.currentReference)) {
          return this.currentReference = this.createReference();
        } else {
          return this.currentReference;
        }
      }
    }, {
      key: "microstate",
      get: function get() {
        return view(this.lens, create(Root, ref.get()));
      }
    }], [{
      key: "allocate",
      value: function allocate(path) {
        var existing = paths.getPath(path.concat(Location.symbol));

        if (existing) {
          return existing;
        } else {
          var location = new Location(path);
          paths.setPath(path, _defineProperty({}, Location.symbol, location));
          return location;
        }
      }
    }]);

    function Location(path) {
      var _this = this;

      _classCallCheck(this, Location);

      this.path = path;
      this.lens = Path(path);
      this.createReferenceType = stable(function (Type) {
        var location = _this;
        var typeName = Type.name ? Type.name : 'Unknown';

        var Reference = function (_Type) {
          _inherits(Reference, _Type);

          function Reference(value) {
            var _this2;

            _classCallCheck(this, Reference);

            _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Reference).call(this, value));
            Object.defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), Meta.symbol, {
              enumerable: false,
              configurable: true,
              value: new Meta(_assertThisInitialized(_assertThisInitialized(_this2)), valueOf(value))
            });
            defineChildren(function (key) {
              return Location.allocate(path.concat(key)).reference;
            }, _assertThisInitialized(_assertThisInitialized(_this2)));
            return _this2;
          }

          return Reference;
        }(Type);

        _defineProperty(Reference, "name", "Ref<".concat(typeName, ">"));

        _defineProperty(Reference, "location", location);

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          var _loop = function _loop() {
            var methodName = _step.value;

            Reference.prototype[methodName] = function () {
              var microstate = location.microstate;
              var next = microstate[methodName].apply(microstate, arguments);
              ref.set(valueOf(next));
              return location.reference;
            };
          };

          for (var _iterator = Object.keys(methodsOf(Type)).concat("set")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return Reference;
      });
    }

    _createClass(Location, [{
      key: "createReference",
      value: function createReference() {
        var Type = this.microstate.constructor.Type;
        var Reference = this.createReferenceType(Type);
        return new Reference(this.currentValue);
      }
    }, {
      key: "get",
      value: function get() {
        var reference = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : paths.getPath([Location.symbol, 'reference']);
        return reference.constructor.location.reference;
      }
    }]);

    return Location;
  }();

  _defineProperty(Location, "symbol", Symbol('Location'));

  return Location.allocate([]);
}

function Identity(microstate) {
  var observe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };
  var Type = microstate.constructor.Type;
  var pathmap = Pathmap(Type, new Storage(valueOf(microstate), function () {
    return observe(pathmap.get());
  }));
  return pathmap.get();
}

function Observable(Microstate) {
  return function (_Microstate) {
    _inherits(_class, _Microstate);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
    }

    _createClass(_class, [{
      key: SymbolObservable,
      value: function value() {
        return this['@@observable']();
      }
    }, {
      key: '@@observable',
      value: function observable() {
        var _this = this;

        return _defineProperty({
          subscribe: function subscribe(observer) {
            var next = observer.call ? observer : observer.next.bind(observer);
            var identity = Identity(_this, next);
            next(identity);
            return identity;
          }
        }, SymbolObservable, function () {
          return this;
        });
      }
    }]);

    return _class;
  }(Microstate);
}

function create() {
  var InputType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Any;
  var value = arguments.length > 1 ? arguments[1] : undefined;

  var _dsl$expand = dsl.expand(InputType),
      Type = _dsl$expand.Type;

  var Microstate = MicrostateType(Type);
  var microstate = new Microstate(value);

  if (Type.prototype.hasOwnProperty('initialize')) {
    return microstate.initialize(value);
  } else {
    return microstate;
  }
}
var MicrostateType = stable(function MicrostateType(Type) {
  var _class, _temp;

  if (Type.Type) {
    return Type;
  }

  var Microstate = (_temp = _class = function (_Observable) {
    _inherits(Microstate, _Observable);

    function Microstate(value) {
      var _this;

      _classCallCheck(this, Microstate);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Microstate).call(this, value));
      Object.defineProperties(_assertThisInitialized(_assertThisInitialized(_this)), map(function (slot, key) {
        return CachedProperty(key, function (self) {
          var value = valueOf(self);
          var expanded = expandProperty(slot);
          var substate = value != null && value[key] != null ? expanded.set(value[key]) : expanded;
          var mounted = mount(self, substate, key);
          return mounted;
        });
      }, _assertThisInitialized(_assertThisInitialized(_this))));
      Object.defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), Meta.symbol, {
        enumerable: false,
        configurable: true,
        value: new Meta(_assertThisInitialized(_assertThisInitialized(_this)), valueOf(value))
      });
      return _this;
    }

    return Microstate;
  }(Observable(Type)), _defineProperty(_class, "name", "Microstate<".concat(Type.name, ">")), _defineProperty(_class, "Type", Type), _temp);
  Object.defineProperties(Microstate.prototype, map(function (descriptor) {
    return {
      value: function value() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var result = descriptor.value.apply(sourceOf(this), args);
        var meta = metaOf(this);
        var previous = valueOf(meta.root);
        var next = set$1(meta.lens, valueOf(result), previous);

        if (meta.path.length === 0 && metaOf(result) != null) {
          return result;
        }

        if (next === previous) {
          return meta.root;
        } else {
          return create(meta.root.constructor, next);
        }
      }
    };
  }, append({
    set: {
      value: function value(x) {
        return x;
      }
    }
  }, methodsOf(Type))));
  return Microstate;
});

function expandProperty(property) {
  var meta = metaOf(property);

  if (meta != null) {
    return property;
  } else {
    var _dsl$expand2 = dsl.expand(property),
        Type = _dsl$expand2.Type,
        value = _dsl$expand2.value;

    return create(Type, value);
  }
}

var Literal = function () {
  function Literal() {
    _classCallCheck(this, Literal);
  }

  _createClass(Literal, [{
    key: "initialize",
    value: function initialize(value) {
      if (value == null) {
        return this;
      }

      value = value.valueOf();

      switch (_typeof(value)) {
        case "number":
          return create(Number, value);

        case "string":
          return create(String, value);

        case "boolean":
          return create(Boolean, value);

        default:
          if (Array.isArray(value)) {
            return create([Literal], value);
          } else {
            return create({
              Literal: Literal
            }, value);
          }

      }
    }
  }]);

  return Literal;
}();

var literal = (function (value) {
  return create(Literal, value);
});

function query(iterable) {
  return new Query(iterable);
}
function map$1(iterable, fn) {
  return query(iterable).map(fn);
}
function filter$1(iterable, fn) {
  return query(iterable).filter(fn);
}
function reduce(iterable, fn, initial) {
  return query(iterable).reduce(fn, initial);
}

var Query = function () {
  function Query(iterable) {
    _classCallCheck(this, Query);

    if (typeof iterable[Symbol.iterator] === 'function') {
      this.generator = function () {
        return iterable[Symbol.iterator]();
      };
    } else if (typeof iterable === 'function') {
      this.generator = iterable;
    } else {
      throw new Error('Query must be constructed with a generator function or iterable. Received `${iterable}`');
    }
  }

  _createClass(Query, [{
    key: "map",
    value: function map$$1(fn) {
      var _this = this;

      return query(function () {
        var source = _this.generator();

        return {
          next: function next() {
            var next = source.next();
            return {
              get done() {
                return next.done;
              },

              get value() {
                return fn(next.value);
              }

            };
          }
        };
      });
    }
  }, {
    key: "filter",
    value: function filter$$1(fn) {
      var _this2 = this;

      return query(function () {
        var source = _this2.generator();

        return {
          next: function next() {
            var result;

            function find() {
              if (result != null) {
                return result;
              } else {
                for (result = source.next(); !result.done && !fn(result.value); result = source.next()) {}

                return result;
              }
            }

            return {
              get done() {
                return find().done;
              },

              get value() {
                return find().value;
              }

            };
          }
        };
      });
    }
  }, {
    key: "reduce",
    value: function reduce(fn, initial) {
      var iterator = this.generator();
      var result = initial;

      for (var next = iterator.next(); !next.done; next = iterator.next()) {
        result = fn(result, next.value);
      }

      return result;
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.generator();
    }
  }, {
    key: "length",
    get: function get() {
      return reduce(this, function (sum) {
        return sum + 1;
      }, 0);
    }
  }]);

  return Query;
}();

export { create, literal as from, map$1 as map, filter$1 as filter, reduce, Identity as Store, metaOf, valueOf, Any, ObjectType, ArrayType, BooleanType, NumberType, StringType, Primitive };
//# sourceMappingURL=microstates.es.js.map
